import React from 'react';
import { useSidebar } from '../context/SidebarContext';
import { useBreadcrumb } from '../context/BreadcrumbContext';

const Settings = () => {
  const { setActivePage } = useSidebar();
  const { setPath } = useBreadcrumb();

  React.useEffect(() => {
    setActivePage('settings');
    setPath([{ title: 'Dashboard', path: '/' }, { title: 'Settings', path: '' }]);
  }, [setActivePage, setPath]);

  return <h1>Settings</h1>;
};

export default Settings;
